// extracted by mini-css-extract-plugin
export default {"modal":"ConfirmButtonModal_modal__3XIc7","title":"ConfirmButtonModal_title__RDTNj","text":"ConfirmButtonModal_text__PID+E","confirmBtn":"ConfirmButtonModal_confirmBtn__rGAT7"};